import { CampaignSchema } from '@kilat/shared';
import { createRepo } from './_base.js';

/**
 * tenants/{tid}/campaigns/{campaignId} — operator-authored marketing
 * broadcasts. Reads + writes by owner|manager; `runCampaignNow` callable
 * runs the actual fan-out and updates `status` + `stats.sent`.
 */
export function campaignsRepoFor(tenantId: string) {
  return createRepo({
    path: `tenants/${tenantId}/campaigns`,
    schema: CampaignSchema,
    name: `tenants/${tenantId}/campaigns`,
  });
}
